import { render, staticRenderFns } from "./AttendanceRules.vue?vue&type=template&id=5bbcea34&scoped=true&"
import script from "./AttendanceRules.vue?vue&type=script&lang=js&"
export * from "./AttendanceRules.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceRules.vue?vue&type=style&index=0&id=5bbcea34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbcea34",
  null
  
)

export default component.exports